import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import useExecScripts from '../Component/useExecScripts'
import EnquiryForm from '../Component/EnquiryForm'
import EnquiryHeading from '../Component/EnquiryHeading'

function EventsDecoration() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const containerRef = useExecScripts();

	return (
		<div id="content" className="site-content">
			<div className="ast-container">
				<div id="primary" className="content-area primary">
					<main id="main" className="site-main">
						<article className="page type-page status-publish ast-article-single">
							<header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
							<div ref={containerRef}>
								<div className="entry-content clear" itemProp="text">


									<div data-elementor-type="wp-page" data-elementor-id="3134" className="elementor elementor-3134">
										<div className="elementor-element elementor-element-4db900e e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="4db900e" data-element_type="container" data-e-type="container">
											<div className="elementor-element elementor-element-1ce5b510 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="1ce5b510" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-4c478285 ekit-equal-height-disable elementor-widget elementor-widget-elementskit-icon-box" data-id="4c478285" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con">        {/* link opening */}
															{/* end link opening */}

															<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
																<div className="elementskit-box-header">
																	<div className="elementskit-info-box-icon ">
																		<img decoding="async" width="2560" height="1707" src="/assets/images/03/CNC07032-scaled.jpg" className="attachment- size-" alt="" srcSet="/assets/images/03/CNC07032-scaled.jpg 2560w, /assets/images/03/CNC07032-300x200.jpg 300w, /assets/images/03/CNC07032-1024x683.jpg 1024w, /assets/images/03/CNC07032-768x512.jpg 768w, /assets/images/03/CNC07032-1536x1024.jpg 1536w, /assets/images/03/CNC07032-2048x1365.jpg 2048w" sizes="(max-width: 2560px) 100vw, 2560px" />                </div>
																</div>
																<div className="box-body">
																	<h3 className="elementskit-info-box-title">
																		Decoration                </h3>
																	<p>
																	</p>
																	<div className="box-footer disable_hover_button">
																		<div className="btn-wraper">
																			<Link className="elementskit-btn whitespace--normal" to="/wedding-events-decoration">
																				EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </Link>
																		</div>
																	</div>
																</div>


															</div>
														</div>				</div>
												</div>
											</div>
											<div className="elementor-element elementor-element-22ecf28e e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="22ecf28e" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-2617adad ekit-equal-height-disable elementor-widget elementor-widget-elementskit-icon-box" data-id="2617adad" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con">        {/* link opening */}
															{/* end link opening */}

															<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
																<div className="elementskit-box-header">
																	<div className="elementskit-info-box-icon ">
																		<img decoding="async" width="1920" height="1080" src="/assets/images/01/cooked-dish.jpg" className="attachment- size-" alt="" srcSet="/assets/images/01/cooked-dish.jpg 1920w, /assets/images/01/cooked-dish-300x169.jpg 300w, /assets/images/01/cooked-dish-1024x576.jpg 1024w, /assets/images/01/cooked-dish-768x432.jpg 768w, /assets/images/01/cooked-dish-1536x864.jpg 1536w" sizes="(max-width: 1920px) 100vw, 1920px" />                </div>
																</div>
																<div className="box-body">
																	<h3 className="elementskit-info-box-title">
																		Games                </h3>
																	<p>


																	</p>
																	<div className="box-footer disable_hover_button">
																		<div className="btn-wraper">
																			<a className="elementskit-btn whitespace--normal" href="/assets/images/06/TSR-Events-Menu-for-Birthday-and-House-Parties.pdf">
																				EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
																		</div>
																	</div>
																</div>


															</div>
														</div>				</div>
												</div>
											</div>
											<div className="elementor-element elementor-element-5064c147 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="5064c147" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-55caadc4 ekit-equal-height-disable elementor-widget elementor-widget-elementskit-icon-box" data-id="55caadc4" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con">        {/* link opening */}
															{/* end link opening */}

															<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
																<div className="elementskit-box-header">
																	<div className="elementskit-info-box-icon ">
																		<img loading="lazy" decoding="async" width="1200" height="580" src="/assets/images/01/Barbecue-dish-item-1.jpg" className="attachment- size-" alt="" srcSet="/assets/images/01/Barbecue-dish-item-1.jpg 1200w, /assets/images/01/Barbecue-dish-item-1-300x145.jpg 300w, /assets/images/01/Barbecue-dish-item-1-1024x495.jpg 1024w, /assets/images/01/Barbecue-dish-item-1-768x371.jpg 768w" sizes="(max-width: 1200px) 100vw, 1200px" />                </div>
																</div>
																<div className="box-body">
																	<h3 className="elementskit-info-box-title">
																		Artists &amp; entertainment                </h3>
																	<p>
																	</p>
																	<div className="box-footer disable_hover_button">
																		<div className="btn-wraper">
																			<a className="elementskit-btn whitespace--normal" href="/assets/images/06/TSR-Events-Menu-for-Birthday-and-House-Parties.pdf">
																				EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
																		</div>
																	</div>
																</div>


															</div>
														</div>				</div>
												</div>
											</div>
											<div className="elementor-element elementor-element-52e9abff e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="52e9abff" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-11031630 ekit-equal-height-disable elementor-widget elementor-widget-elementskit-icon-box" data-id="11031630" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con">        {/* link opening */}
															{/* end link opening */}

															<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
																<div className="elementskit-box-header">
																	<div className="elementskit-info-box-icon ">
																		<img loading="lazy" decoding="async" width="1200" height="580" src="/assets/images/01/Barbecue-dish-item-1.jpg" className="attachment- size-" alt="" srcSet="/assets/images/01/Barbecue-dish-item-1.jpg 1200w, /assets/images/01/Barbecue-dish-item-1-300x145.jpg 300w, /assets/images/01/Barbecue-dish-item-1-1024x495.jpg 1024w, /assets/images/01/Barbecue-dish-item-1-768x371.jpg 768w" sizes="(max-width: 1200px) 100vw, 1200px" />                </div>
																</div>
																<div className="box-body">
																	<h3 className="elementskit-info-box-title">
																		Rental Equipments                </h3>
																	<p>
																	</p>
																	<div className="box-footer disable_hover_button">
																		<div className="btn-wraper">
																			<a className="elementskit-btn whitespace--normal" href="/assets/images/06/TSR-Events-Menu-for-Birthday-and-House-Parties.pdf">
																				EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
																		</div>
																	</div>
																</div>


															</div>
														</div>				</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-34b3394a e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="34b3394a" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-da3baf3 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="da3baf3" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
												<div className="e-con-inner">
													<div className="elementor-element elementor-element-4a3d6096 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="4a3d6096" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
																												<EnquiryHeading widgetElementId="11f565a5" />

																												<EnquiryForm widgetElementId="2adb27aa" />

													</div>
												</div>
											</div>
										</div>
									</div>



								</div>
							</div>
						</article>
					</main>
				</div>
			</div>
		</div>
	)
}

export default EventsDecoration

